import { getUiDateShort } from 'shared/lib/dates';

export const sitePeriod = (state) => state.site?.period;
export const sitePeriodFormatted = (state) => ({
  start: getUiDateShort(state.site?.period?.start),
  end: getUiDateShort(state.site?.period?.end)
});

export const sitePeriodPerformance = (state) => state.site?.periodPerformance;
